import React from 'react';

/**
 * In-app confirm/result dialog for Admin — avoids browser chrome that
 * shows the full Azure hostname above window.confirm().
 *
 * actions: [{ key, label, variant?: 'primary'|'danger'|'outline', disabled? }]
 */
export default function AdminConfirmModal({
  open,
  title,
  children,
  actions = [],
  onClose,
  busy = false,
}) {
  if (!open) return null;

  return (
    <div
      className="admin-modal-overlay admin-confirm-overlay"
      onClick={() => { if (!busy && onClose) onClose(); }}
      role="presentation"
    >
      <div
        className="admin-modal admin-confirm-modal card"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
        aria-labelledby="admin-confirm-title"
      >
        <div className="admin-modal-header">
          <h3 id="admin-confirm-title">{title}</h3>
          {!busy && onClose && (
            <button type="button" className="btn btn-outline btn-sm" onClick={onClose}>
              Close
            </button>
          )}
        </div>
        <div className="admin-confirm-body">
          {typeof children === 'string'
            ? children.split('\n').map((line, i) => (
                <p key={i} className={line.trim() ? undefined : 'admin-confirm-spacer'}>
                  {line}
                </p>
              ))
            : children}
        </div>
        {actions.length > 0 && (
          <div className="admin-confirm-actions">
            {actions.map((a) => (
              <button
                key={a.key}
                type="button"
                className={`btn btn-sm ${
                  a.variant === 'danger'
                    ? 'btn-danger'
                    : a.variant === 'outline'
                      ? 'btn-outline'
                      : 'btn-primary'
                }`}
                disabled={busy || a.disabled}
                onClick={a.onClick}
              >
                {a.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
